import { render } from "./FormInputSwitch.vue?vue&type=template&id=3de15da8"
import script from "./FormInputSwitch.vue?vue&type=script&lang=js"
export * from "./FormInputSwitch.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\MAX\\Documents\\Repositorios\\gem_tpv_pwa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__